/**
 * @generated SignedSource<<18b8ca6ebdb4df4e764070e4496bc6e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BaseNativeDeviceTokendeviceOsEnumType = "android" | "ios";
export type NativeDeviceOs = "android" | "ios";
export type CreateNativeDeviceTokenInput = {
  clientMutationId?: string | null;
  deviceOs: NativeDeviceOs;
  deviceToken: string;
  deviceUniqueId?: string | null;
};
export type createNativeDeviceTokenMutation$variables = {
  input: CreateNativeDeviceTokenInput;
};
export type createNativeDeviceTokenMutationVariables = createNativeDeviceTokenMutation$variables;
export type createNativeDeviceTokenMutation$data = {
  readonly createNativeDeviceToken: {
    readonly nativeDeviceToken: {
      readonly deviceToken: string;
      readonly deviceOs: BaseNativeDeviceTokendeviceOsEnumType | null;
      readonly deviceUniqueId: string;
    } | null;
  } | null;
};
export type createNativeDeviceTokenMutationResponse = createNativeDeviceTokenMutation$data;
export type createNativeDeviceTokenMutation = {
  variables: createNativeDeviceTokenMutationVariables;
  response: createNativeDeviceTokenMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceToken",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceOs",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceUniqueId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createNativeDeviceTokenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateNativeDeviceTokenPayload",
        "kind": "LinkedField",
        "name": "createNativeDeviceToken",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NativeDeviceToken",
            "kind": "LinkedField",
            "name": "nativeDeviceToken",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createNativeDeviceTokenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateNativeDeviceTokenPayload",
        "kind": "LinkedField",
        "name": "createNativeDeviceToken",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NativeDeviceToken",
            "kind": "LinkedField",
            "name": "nativeDeviceToken",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c76545404797567605c40f6e849821a7",
    "id": null,
    "metadata": {},
    "name": "createNativeDeviceTokenMutation",
    "operationKind": "mutation",
    "text": "mutation createNativeDeviceTokenMutation(\n  $input: CreateNativeDeviceTokenInput!\n) {\n  createNativeDeviceToken(input: $input) {\n    nativeDeviceToken {\n      deviceToken\n      deviceOs\n      deviceUniqueId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "287198208566d63fd8f5d349ee96e7be";

export default node;
